export const frontend_large_projects = [
  {
    name: 'E-commerce store',
    image: '/images/e-commerce.jpg',
    url: 'https://e-commerce-store-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/E-commerce-website-with-react',
  },
  {
    name: 'Jobify',
    image: '/images/jobify.jpg',
    url: 'https://jobify-fullstack-mern.herokuapp.com',
    git: 'https://github.com/joseokwu/jobify-fullstack-mern',
  },
  {
    name: 'Natours',
    image: '/images/natours.png',
    url: 'https://natours-plum.vercel.app/',
    git: 'https://github.com/joseokwu/natours',
  },
  {
    name: 'Github Users',
    image: '/images/github-users.jpg',
    url: 'https://search-github-users-reactjs01.netlify.app/',
    git: 'https://github.com/joseokwu/search-github-user-react-',
  },
  {
    name: 'Quiz Game',
    image: '/images/quiz.jpg',
    url: 'https://quiz-game-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/quiz-game',
  },
  {
    name: 'Cart',
    image: '/images/cart.jpg',
    url: 'https://cart-with-reactjs.netlify.app/',
    git: 'https://github.com/joseokwu/cart',
  },
  {
    name: 'News Search',
    image: '/images/news-search.jpg',
    url: 'https://news-search-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/news-search ',
  },
  {
    name: 'Dynamic Menu',
    image: '/images/menu.jpg',
    url: 'https://https://dynamic-menu-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/menu-with-react',
  },
  {
    name: 'Grocery List',
    image: '/images/grocery-list.jpg',
    url: 'https://grocery-list-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/grocery-list',
  },
  {
    name: 'Cocktail Kiosk',
    image: '/images/cocktail-kiosk.jpg',
    url: 'https://cocktail-kiosk-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/cocktails',
  },
  {
    name: 'Color Generator',
    image: '/images/color-generator.jpg',
    url: 'https://color-generator-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/color-generator',
  },
  {
    name: 'SubMenus',
    image: '/images/submenus.jpg',
    url: 'https://submenus-with-react.netlify.app',
    git: 'https://github.com/joseokwu/submenus',
  },
  {
    name: 'Pagination',
    image: '/images/pagination.jpg',
    url: 'https://pagination-with-reactjs.netlify.app/',
    git: 'https://github.com/joseokwu/pagination-with-react',
  },
  {
    name: 'Movies DB',
    image: '/images/movies-db.jpg',
    url: 'https://movies-db-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/movies-db-with-react',
  },
  {
    name: 'Tours',
    image: '/images/tours.jpg',
    url: 'https://tours-with-react.netlify.app',
    git: 'https://github.com/joseokwu/tours-with-react',
  },
  {
    name: 'Tabs',
    image: '/images/tabs.jpg',
    url: 'https://tabs-with-react.netlify.app',
    git: 'https://github.com/joseokwu/tabs-with-react',
  },
  {
    name: 'Reviews',
    image: '/images/reviews.jpg',
    url: 'https://reviews-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/reviews-with-react',
  },
  {
    name: 'Sidebar Modal',
    image: '/images/sidebar-modal.jpg',
    url: 'https://sidebar-modal-with-react.netlify.app',
    git: 'https://github.com/joseokwu/sidebar-modal-with-react',
  },
  {
    name: 'Slider',
    image: '/images/slider.jpg',
    url: 'https://slider-with-react.netlify.app',
    git: 'https://github.com/joseokwu/slider-with-react',
  },
  {
    name: 'Random User',
    image: '/images/random-user.jpg',
    url: 'https://random-user-with-reactjs.netlify.app',
    git: 'https://github.com/joseokwu/random-person-with-react',
  },
  {
    name: 'Dark Mode',
    image: '/images/dark-mode.jpg',
    url: 'https://dark-mode-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/dark-mode-with-react',
  },
  {
    name: 'Accordion',
    image: '/images/accordion.jpg',
    url: 'https://accordion-with-react.netlify.app',
    git: 'https://github.com/joseokwu/accordion-with-react',
  },
  {
    name: 'Birthday Reminder',
    image: '/images/birthday-reminder.jpg',
    url: 'https://birthday-reminder-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/birthday-reminder-with-react',
  },
  {
    name: 'Markdown Preview',
    image: '/images/markdown-preview.jpg',
    url: 'https://markdown-preview-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/markdown-preview-with-react',
  },
  {
    name: 'Lorem Ipsum',
    image: '/images/lorem-ipsum.jpg',
    url: 'https://lorem-ipsum-with-react.netlify.app/',
    git: 'https://github.com/joseokwu/lorem-ipsum-with-react',
  },
  {
    name: 'Navbar',
    image: '/images/navbar.jpg',
    url: 'https://navbar-with-react00.netlify.app/',
    git: 'https://github.com/joseokwu/navbar-with-react',
  },
];

export const frontend_regular_projects = [
  {
    name: 'Quiz Game',
    image: '/images/quiz.jpg',
    url: 'https://quiz-game-with-react.netlify.app/',
  },
  {
    name: 'Cart',
    image: '/images/cart.jpg',
    url: 'https://cart-with-reactjs.netlify.app/',
  },
  {
    name: 'News Search',
    image: '/images/news-search.jpg',
    url: 'https://news-search-with-react.netlify.app/',
  },
  {
    name: 'Dynamic Menu',
    image: '/images/menu.jpg',
    url: 'https://https://dynamic-menu-with-react.netlify.app/',
  },
  {
    name: 'Grocery List',
    image: '/images/grocery-list.jpg',
    url: 'https://grocery-list-with-react.netlify.app/',
  },
  {
    name: 'Cocktail Kiosk',
    image: '/images/cocktail-kiosk.jpg',
    url: 'https://cocktail-kiosk-with-react.netlify.app/',
  },
  {
    name: 'Color Generator',
    image: '/images/color-generator.jpg',
    url: 'https://color-generator-with-react.netlify.app/',
  },
  {
    name: 'SubMenus',
    image: '/images/submenus.jpg',
    url: 'https://submenus-with-react.netlify.app',
  },
  {
    name: 'Pagination',
    image: '/images/pagination.jpg',
    url: 'https://pagination-with-reactjs.netlify.app/',
  },
  {
    name: 'Movies DB',
    image: '/images/movies-db.jpg',
    url: 'https://movies-db-with-react.netlify.app/',
  },
  {
    name: 'Tours',
    image: '/images/tours.jpg',
    url: 'https://tours-with-react.netlify.app',
  },
  {
    name: 'Tabs',
    image: '/images/tabs.jpg',
    url: 'https://tabs-with-react.netlify.app',
  },
  {
    name: 'Reviews',
    image: '/images/reviews.jpg',
    url: 'https://reviews-with-react.netlify.app/',
  },
  {
    name: 'Sidebar Modal',
    image: '/images/sidebar-modal.jpg',
    url: 'https://sidebar-modal-with-react.netlify.app',
  },
  {
    name: 'Slider',
    image: '/images/slider.jpg',
    url: 'https://slider-with-react.netlify.app',
  },
  {
    name: 'Random User',
    image: '/images/random-user.jpg',
    url: 'https://random-user-with-reactjs.netlify.app',
  },
  {
    name: 'Dark Mode',
    image: '/images/dark-mode.jpg',
    url: 'https://dark-mode-with-react.netlify.app/',
  },
  {
    name: 'Accordion',
    image: '/images/accordion.jpg',
    url: 'https://accordion-with-react.netlify.app',
  },
  {
    name: 'Birthday Reminder',
    image: '/images/birthday-reminder.jpg',
    url: 'https://birthday-reminder-with-react.netlify.app/',
  },
  {
    name: 'Markdown Preview',
    image: '/images/markdown-preview.jpg',
    url: 'https://markdown-preview-with-react.netlify.app/',
  },
  {
    name: 'Lorem Ipsum',
    image: '/images/lorem-ipsum.jpg',
    url: 'https://lorem-ipsum-with-react.netlify.app/',
  },
  {
    name: 'Navbar',
    image: '/images/navbar.jpg',
    url: 'https://navbar-with-react00.netlify.app/',
  },
];
